import React from "react";

const NotFoundPage: React.FC = () => {
  const goBack = () => window.history.back();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4">
      <div className="backdrop-blur-xl  shadow-xl border border-white/60 rounded-2xl p-8 max-w-md w-full text-center">
        
        <h1 className="text-7xl font-extrabold text-gray-800 mb-4">404</h1>
        <p className="text-gray-600 text-lg mb-6">
          Oops! The page you are looking for does not exist.
        </p>

        <div className="flex flex-col gap-3">
          <button
            onClick={goBack}
            className="bg-primary hover:bg-blue-900 transition text-white py-2 px-4 rounded-lg"
          >
            Go Back
          </button>

          <a
            href="/"
            className="bg-gray-200 hover:bg-gray-300 transition text-gray-800 py-2 px-4 rounded-lg"
          >
            Go Home
          </a>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
